import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { mongoId } from '../../../../@core/common/global';
import { ApiService } from '../../../../@core/service/api.service';
import { SharedDataService } from '../../../../@core/service/shared-data.service';
import { DocumentSelectComponent } from './document-select.component';
import { AbstractItem, AbstractItemType } from '../../abstractItem';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'ngx-project-selector',
  templateUrl: '../document-select/document-select.component.html',
  styleUrls: ['../document-select/document-select.component.scss'],
})
export class ProjectSelectorComponent extends DocumentSelectComponent implements OnInit, OnChanges {

  @Input() businessId: string;

  constructor(public api: ApiService, public data: SharedDataService) {
    super(data);
    this.showBusinessInput = true;
    this.title = 'Projects';
  }

  async ngOnChanges(changes: SimpleChanges): Promise<void> {
    if (changes.businessId) {
      this.businessId = mongoId(changes.businessId.currentValue);
      if (!this.initialItems?.length) {
        this.initialItems = await firstValueFrom(this.api.projects()) as any;
      }
      this.init();
    }
  }

  onBusinessIdChanged(businessId: string) {
    this.businessId = businessId;
    this.init();
  }

  init() {
    this.latestVersionItems = [...this.initialItems].filter((f: any) => f.active && (!this.businessId || mongoId(f.business) === this.businessId));
    this.onFilter();
  }

  preFilter(items: AbstractItemType[]): AbstractItemType[] {
    return [];
  }

  columns = [
    { id: 'businessUnit', title: 'Business Unit', search: '' },
    { id: 'name', title: 'Project ID', search: '' },
    { id: 'baseProduct', title: 'Base Product', search: '' },
  ]

  getText(col: string, item: any) {
    if (!item) return '';
    switch (col) {
      case 'name': return item.name || '';
      case 'businessUnit': return item.businessUnit || '';
      case 'baseProduct': return item.baseProduct?.name || '';
      default: return item[col];
    }
  }

}